import React from 'react'
import {FormatUtcDateAsLocal} from '../../../../../../helpers/datetime'
import { getEventDescription } from '../../../../../../helpers/eventDescription'
import * as Badges from '../../../../../../components/badges'
import PropTypes from "prop-types"

const DriverPoolTakenOffline = (props) => {
  return <tr>
    <td><Badges.Offline/></td>
    <td>{getEventDescription(props.item, 'Delivery pool taken offline')}</td>
    <td>{FormatUtcDateAsLocal(props.item.createdUtc)}</td>
    <td>{props.item.createdBy}</td>
  </tr>
}

DriverPoolTakenOffline.propTypes = {
  item: PropTypes.object
}

export default DriverPoolTakenOffline


// WEBPACK FOOTER //
// ./src/containers/pools/details/logs/components/driverPoolTakenOffline/index.js